import React from 'react';
import MainLayout from '../layout/MainLayout';
import _NotFound from '../components/_NotFound';

const NotFoundPage = () => {
    return (
        <MainLayout>
            <_NotFound />
        </MainLayout>
    )
}

export default NotFoundPage